module.exports = __webpack_public_path__ + "img/logo_pg_nova.0f6a0d3a.svg";